import React from 'react';

/**
 * ToggleSwitch reutilizable (slider tipo iOS/Android)
 * Props:
 * - checked: boolean
 * - onChange: function
 * - label: string (opcional)
 * - disabled: boolean (opcional)
 * - className: string (opcional)
 */
const ToggleSwitch = ({ checked, onChange, label, disabled, className = '', labelClassName = '' }) => (
  <label className={`flex items-center cursor-pointer select-none ${className} ${disabled ? 'opacity-60 pointer-events-none' : ''}`}>
    <div className="relative">
      <input
        type="checkbox"
        checked={checked}
        onChange={e => onChange(e.target.checked)}
        disabled={disabled}
        className="sr-only peer"
      />
      <div className={`w-7 h-4 bg-gray-300 peer-checked:bg-blue-600 rounded-full transition-colors duration-200`}></div>
      <div className={`absolute top-0 left-0 w-4 h-4 bg-white border border-gray-300 rounded-full shadow transform transition-transform duration-200 peer-checked:translate-x-3`}></div>
    </div>
    {label && <span className={`ml-2 dark:text-white ${labelClassName}`}>{label}</span>}
  </label>
);

export default ToggleSwitch;
